const en = {
    translation: {
        allocation: 'ALLOCATION',
        ftnContractAddress: 'FTN Contract Address',
        ftnDistributionAddress: 'FTN Distribution Address',
        ftnCustomDistributionAddress: 'FTN Custom Distribution Address',
        info: 'info',
        FTNInfo: 'FTN Info',
        connectWalletParagraph: 'You have arrived at the FTN allocation claim poge. Here, you will be able to view your FTN allocation timeline and claim all available FTNs. Please connect your Ethereum Wallet (MetaMask, Trust Wallet, WalletConnect, etc.) to continue.',
        connectWalletButton: 'CONNECT WALLET',
        myWalletAddress: 'My Wallet Address',
        allocationInfoCardParagraph: 'You have arrived at the FTN allocation claim poge. Here, you will be able to view your FTN allocation timeline and claim all available FTNs.',
        addFtnToWallet: 'ADD FTN TO WALLET',
        claimFtn: 'Claim FTN',
        noAllocationCardParagraph: 'Looks like the address that you\'ve connected with doesn\'t have any FTN allocation on the distribution smart contract. Please use the same address that you have provided to us previously to view your allocation.',
        allocationType: 'Allocation Type',
        unlockCondition: 'Unlock Condition',
        claimed: 'Claimed',
        currentStatus: 'Current Status',
        totalUnclaimed: 'Total Unclaimed',
        availableToClaim: 'Available to Claim',
        claimNow: 'Claim Now',
        connectWallet: 'Connect Wallet',
        logOut: 'logOut',
        footerInfoText: 'The token that constructs possibilities',
        quickLinks: 'Quick Links',
        termsAndConditions: 'Terms and Conditions',
        newsroom: 'Newsroom',
        documentation: 'Documentation',
        collectables: 'Collectables',
        ftnUsability: 'FTN Usability',
        emailSubscription: 'Email Subscription',
        subscribe: 'Subscribe',
        copyrightText: 'Copyright © 2023 Fasttoken. All Rights Reserved.',
        contactUs: 'Contact Us',
        chooseYourWaller: 'Choose your wallet',
        connect: 'connect',
        completedSuccessfully: 'Completed successfully',
        somethingWentWrong: 'Something went wrong',
        pending: 'Pending',
        waitingTransaction: 'Waiting for transaction confirmation',
        aboutUs: 'About Us',
    },
};

export default en;
